export const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: 'transparent',
      color: 'var(--bgColorSecondary)',
      boxShadow: "none",
      borderColor: "#ccc",
      "&:hover": {
        borderColor: "#aaa",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'var(--textColor)',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'var(--bgColorSecondary)',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'var(--bgColor)' : 'var(--bgColor)',
      color: state.isSelected ? 'var(--textColor)' : 'var(--textColor)',
      '&:hover': {
        backgroundColor: 'var(--hoverBg)',
        color: 'var(--textColor)',
      },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: 'var(--bgColor)',
      zIndex: 9999,
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '300px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      '&::-webkit-scrollbar': {
        width: '6px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#ccc',
        borderRadius: '3px',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
      },
    }),
  };


